import {NgModule} from '@angular/core';
import {SecondToMinutePipe} from '../pipe/second-to-minutes/second-to-minute.pipe';
import {ConvertNumberToPersianPipe} from '../pipe/convert-number-persian/convert-number-to-persian.pipe';
import {DateConverterPipe} from '../pipe/date-convert/date-converter.pipe';
import {TooltipDirective} from '../directive/tooltip.directive';
import {SafeHtmlPipe} from '../pipe/safe-html/safe-html.pipe';


@NgModule({
    imports: [],
    declarations: [SecondToMinutePipe, ConvertNumberToPersianPipe, DateConverterPipe, TooltipDirective,SafeHtmlPipe],
    exports: [SecondToMinutePipe, ConvertNumberToPersianPipe, DateConverterPipe, TooltipDirective,SafeHtmlPipe]
})
export class ShareModule {

}
